import React from "react";
import ReactDOM from "react-dom";

import { t } from "@web-solutions/module-localization";

import { Preloader } from "core/ui-elements";

import classes from "./style.module.scss";

interface Props {
  /** When true, a full-screen blocking loader is shown over the whole page. */
  visible: boolean;
  /** Optional override for the default "Processing payment, please wait..." text. */
  text?: React.ReactNode;
}

/**
 * Full-screen blocking loader shown while a payment is being processed.
 *
 * Rendered into `document.body` (above the payment modal / react-modal portal)
 * so that, the moment a payment method is authorized — e.g. when the native
 * Apple Pay sheet or the bank 3-D Secure window closes — the whole page is
 * locked and no further clicks reach the payment form until the success
 * redirect happens.
 */
const PaymentProcessingOverlay: React.FC<Props> = ({ visible, text }) => {
  if (!visible || typeof document === "undefined") {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={classes.overlay} role="alert" aria-busy="true">
      <div className={classes.content}>
        <Preloader className={classes.spinner} />
        <p className={classes.text}>
          {text || t("core.payment_popup.processing")}
        </p>
      </div>
    </div>,
    document.body,
  );
};

export default PaymentProcessingOverlay;
